import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AccountService } from './api/account.service';
import { AntibioticSummaryService } from './api/antibioticSummary.service';
import { ClarificationsService } from './api/clarifications.service';
import { ControlledMedOrdersService } from './api/controlledMedOrders.service';
import { ControlledSubstanceDisposalService } from './api/controlledSubstanceDisposal.service';
import { DashboardService } from './api/dashboard.service';
import { DocumentService } from './api/document.service';
import { DocumentsPendingService } from './api/documentsPending.service';
import { FileDownloadService } from './api/fileDownload.service';
import { FinancialService } from './api/financial.service';
import { InvoiceApprovalService } from './api/invoiceApproval.service';
import { MedAlertService } from './api/medAlert.service';
import { MedSearchService } from './api/medSearch.service';
import { MedicationRefillsService } from './api/medicationRefills.service';
import { MedicationReturnsService } from './api/medicationReturns.service';
import { MedicationSummaryService } from './api/medicationSummary.service';
import { OrderStatusService } from './api/orderStatus.service';
import { OrderSummaryService } from './api/orderSummary.service';
import { OwedMedicationService } from './api/owedMedication.service';
import { PsychotropicSummaryService } from './api/psychotropicSummary.service';
import { ReportsService } from './api/reports.service';
import { ResidentService } from './api/resident.service';
import { ResourceService } from './api/resource.service';
import { Saml2Service } from './api/saml2.service';
import { SampleService } from './api/sample.service';
import { UserService } from './api/user.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AccountService,
    AntibioticSummaryService,
    ClarificationsService,
    ControlledMedOrdersService,
    ControlledSubstanceDisposalService,
    DashboardService,
    DocumentService,
    DocumentsPendingService,
    FileDownloadService,
    FinancialService,
    InvoiceApprovalService,
    MedAlertService,
    MedSearchService,
    MedicationRefillsService,
    MedicationReturnsService,
    MedicationSummaryService,
    OrderStatusService,
    OrderSummaryService,
    OwedMedicationService,
    PsychotropicSummaryService,
    ReportsService,
    ResidentService,
    ResourceService,
    Saml2Service,
    SampleService,
    UserService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
